module.exports = __webpack_public_path__ + "img/film.5e57d8a2.svg";